const USER_STORAGE_PREFIX = "anina:user:";

function assertUserId(userId) {
  const normalized = String(userId || "").trim();
  if (!normalized) {
    throw new Error("Authenticated user id is required for private storage.");
  }
  return normalized;
}

export function userStoragePrefix(userId) {
  return `${USER_STORAGE_PREFIX}${assertUserId(userId)}:`;
}

export function createUserScopedStorage(userId, storage = window.localStorage) {
  const prefix = userStoragePrefix(userId);
  const physicalKey = (key) => `${prefix}${String(key)}`;

  const logicalKeys = () => {
    const keys = [];
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (key?.startsWith(prefix)) keys.push(key.slice(prefix.length));
    }
    return keys;
  };

  return {
    get length() {
      return logicalKeys().length;
    },
    key(index) {
      return logicalKeys()[index] ?? null;
    },
    getItem(key) {
      return storage.getItem(physicalKey(key));
    },
    setItem(key, value) {
      storage.setItem(physicalKey(key), String(value));
    },
    removeItem(key) {
      storage.removeItem(physicalKey(key));
    },
    clear() {
      logicalKeys().forEach((key) => storage.removeItem(physicalKey(key)));
    },
  };
}

export default createUserScopedStorage;
